import classNames from 'classnames/bind';
import styles from './ProjectList.module.scss';
import ProjectItem2 from './ProjectItem2';

const cx = classNames.bind(styles);

function ProjectList({ data = [] , handleRemove}) {
  
  return (
    <div className={cx('project-list')}>
      {data.map((prj, index) => (
        <div key={index} className={cx("wrap-item")}><ProjectItem2 data = {prj} handleRemove = {handleRemove}/></div>
      ))}
    </div>
  );
}

export default ProjectList;
